import { render, staticRenderFns } from "./SelectedContact.vue?vue&type=template&id=db032938"
import script from "./SelectedContact.vue?vue&type=script&lang=js"
export * from "./SelectedContact.vue?vue&type=script&lang=js"
import style0 from "./SelectedContact.vue?vue&type=style&index=0&id=db032938&prod&lang=css"
import style1 from "./SelectedContact.vue?vue&type=style&index=1&id=db032938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports